import { FunctionComponent, useState, MouseEvent } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { CalendarEventInput, buildGoogleCalendarUrl, downloadIcsFile } from "../utils/calendarLinks";

interface AddToCalendarButtonProps {
  event: CalendarEventInput;
  size?: "small" | "medium" | "large";
}

const AddToCalendarButton: FunctionComponent<AddToCalendarButtonProps> = ({ event, size = "small" }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e: MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleGoogleCalendar = () => {
    window.open(buildGoogleCalendarUrl(event), "_blank", "noopener,noreferrer");
    handleClose();
  };

  const handleDownloadIcs = () => {
    downloadIcsFile(event);
    handleClose();
  };

  return (
    <>
      <Button
        size={size}
        variant="outlined"
        startIcon={<CalendarMonthIcon fontSize="small" />}
        onClick={handleOpen}
      >
        Add to Calendar
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleGoogleCalendar}>Google Calendar</MenuItem>
        <MenuItem onClick={handleDownloadIcs}>Apple / Outlook (.ics)</MenuItem>
      </Menu>
    </>
  );
};

export default AddToCalendarButton;
